<template>
  <div id="login">

    <LoginMobile :login="login" :toNoAccount="toNoAccount" :resetPassword="resetPassword" :setCurrentPage="setCurrentPage"
                 :user="user" :show="show"
                 v-show="!$store.state.isDesktop"
    ></LoginMobile>

    <LoginDesktop :login="login" :toNoAccount="toNoAccount" :resetPassword="resetPassword" :setCurrentPage="setCurrentPage"
                  :user="user" :show="show"
                  v-show="$store.state.isDesktop"
    ></LoginDesktop>

</div>
</template>

<script>

  import User from "../../core/User";
  import Configuration from '../../core/Configuration';
  import moment from "moment";
  import LoginMobile from '@/components/mobile/Login';
  import LoginDesktop from '@/components/desktop/Login';
  import store from "../store";

  export default {

    name: "login",

    components: {
      LoginMobile,
      LoginDesktop
    },

    data() {
      return {
        user: {
          username: "",
          password: "",
          emailForgot: "",
          rememberMe: false
        },
        show: "intro"
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: this.$store.state.isDesktop,
        showHeaderLeft: false,
        showFooter: false
      });
      if (User.token != null) {
        this.$router.push("/home");
      }
    },

    methods: {
      async login() {
        showSpinner();
        let result;
        try {
          result = await User.login(this.user.username, this.user.password);
        } catch (e) {
          console.log(e);
          hideSpinner();
          if (e.response && e.response.status == 401) {
            showAffirmation(this.$t("oops"), this.$t("login.error_401") + (!this.$store.state.cogir ? this.$t("login.error_401_humaniti") : ""));
          } else {
            showAffirmation(this.$t("oops"), this.$t("login.error_rest"));
          }
          return;
        }
        if (User.role != "ROLE_TENANT") {
          hideSpinner();
          User.logout();
          showAffirmation(this.$t("error"), this.$t("login.error_rest"));
          this.user.password = "";
          return;
        }
        if (localStorage.getItem('FCMToken')) {
          await User.saveDeviceToken(localStorage.getItem('FCMToken'));
        }
        hideSpinner();
        this.$router.push("/home");
      },
      async resetPassword() {
        if (this.user.emailForgot.length == 0) {
          return;
        }
        showSpinner();
        //TODO -Passer en param la bonne compagnie pour le branding du email et le bon redirect URL
        try{
          let result = await User.resetPassword(this.user.emailForgot, this.$ts.state.locale, this.$store.state.cogir ? "octopus" : "humaniti" );
        } catch (e) {
          console.log(e);
          hideSpinner();
          showAffirmation(this.$t("error"), this.$t("login.error_rest"));
          return;
        }
        hideSpinner();
        this.user.emailForgot = "";
        showAffirmation(this.$t("login.password_sent"), this.$t("login.password_sent_text"));
        this.setCurrentPage('login');
      },
      toNoAccount() {
        this.$router.push("/no-account");
      },
      setCurrentPage(pageToShow) {
        this.show = pageToShow;
      }

    }

  }

</script>

<style lang="scss" scoped>

  #login {
    overflow-x: hidden;
  }

</style>